import React, { useState, useRef } from 'react';
import { Popup } from "semantic-ui-react";

import Outclik from '../outclick';

import { stopEventPropagation } from '../../../helpers/event_helpers';

import './tags_dropdown.css';

const filterOptions = (tagOptions, searchTerm) => {
  return tagOptions.filter((item)=>{
    return item.toLowerCase().includes(searchTerm.toLowerCase())
  })
}

export default function TagsDropdown (props) {
  const elementRef = useRef();
  const { tagOptions, tagList } = props;

  const defaultState = {
    showDropdown: false,
    searchTerm: '',
    newOption: '',
    showNewOption: false
  }
  const [state, setState] = useState(defaultState);
  const searchPlaceholder = props.searchPlaceholder ? props.searchPlaceholder : 'Search tags';
  const newPlaceholder = props.newPlaceholder ? props.newPlaceholder : 'Enter new tag';
  const sortedTagOptions = tagOptions ? tagOptions.sort() : [];
  const filteredTagOptions = state.searchTerm.length > 0 ? filterOptions(sortedTagOptions, state.searchTerm) : sortedTagOptions;
  
  const showDropdown = (evt) => {
    evt.stopPropagation();
    setState({...state, showDropdown: true})
  }

  const toggleNewOption = () => {
    setState({...state, showNewOption: !state.showNewOption})
  }

  const onItemClick = (item) => { 
    const { confirmRemove, confirmRemoveCallback } = props;

    if (tagList.includes(item)) {
      if (confirmRemove && item==='Active'){
        confirmRemoveCallback(item);
      } else {
        removeItemFromList(tagList, item);
      }
    } else {
      addItemToList(tagList, item);
    }
  }

  const addItemToList = (tagList, item) => {
    tagList.push(item)
    udpateTagList(tagList)
  }

  const removeItemFromList = (tagList, item) => {
    var index = tagList.indexOf(item);
    if (index !== -1) tagList.splice(index, 1);
    udpateTagList(tagList)
  }

  const udpateTagList = (tagList) => {
    props.onApply(tagList)
  }

  const onSearch = (evt) => {
    setState({...state, searchTerm: evt.target.value})
  }

  const onNewChange = (evt) => {
    setState({...state, newOption: evt.target.value})
  }

  const saveNewOption = (evt) => {
    let { newOption } = state;

    props.onNewTag(newOption)

    if (!tagList.includes(newOption)){
      addItemToList(tagList, newOption)
    }

    resetNewOption()
  }

  const resetNewOption = (evt) => {
    setState({...state, newOption: '', showNewOption: false})
  }

  const closeAndApplyChanges = (e) => {
    setState({...state, showDropdown: false, newOption: '', showNewOption: false});
    if (props.doneable && props.onDone) props.onDone();
  }

  return (
    <Popup
      className={props.className || "tags-dropdown"}
      style={props.style}
      trigger={props.trigger}
      open={state.showDropdown}
      onOpen={showDropdown}
      content={
        <Outclik ref={elementRef} id='dropdown-modal' className="dropdown-modal" onClick={stopEventPropagation} handleClick={closeAndApplyChanges}>
          <div className="dropdown-modal-header">
            <div>{props.header}</div>
            {
              props.searchable &&
              <form autoComplete="off">
                <div className="search-tag-container">
                  <input type="text" name="search_tag" defaultValue={state.searchTerm} onChange={onSearch} placeholder={searchPlaceholder}/>
                </div>
              </form>
            }
          </div>
          <div className="dropdown-modal-content">
            <ul>
              {
                filteredTagOptions.map((item, index)=>{
                  return (
                    <li key={index} onClick={(evt)=>onItemClick(item)}>
                      <input type="checkbox" checked={tagList.includes(item)}/>&nbsp;&nbsp;{item}
                    </li>
                  )
                })
              }
            </ul>
            {
              state.searchTerm.length > 0 && filteredTagOptions.length === 0 &&
              <ul>
                <li>No match found</li>
              </ul>
            }
          </div>
          <div className="dropdown-modal-footer">
            {
              props.addable &&
              <React.Fragment>
                {
                  !state.showNewOption &&
                  <div className="action" onClick={toggleNewOption}>Create New</div>
                }
                {
                  state.showNewOption &&
                  <div className="create-new-container">
                    <form autoComplete="off">
                      <input type="text" name="new_tag" defaultValue={state.newOption} onChange={onNewChange} placeholder={newPlaceholder}/>
                    </form>
                    <div className="action" onClick={saveNewOption}>Save</div>
                    <div className="action" onClick={resetNewOption}>Cancel</div>
                  </div>
                }
              </React.Fragment>
            }
            {
              props.doneable && props.onDone && !state.showNewOption && <div className="action" onClick={closeAndApplyChanges}>Apply</div>
            }
          </div>
        </Outclik>
      }
      on="click"
      basic
      hideOnScroll
    />
  )
}




// WEBPACK FOOTER //
// ./src/views/components/tag_components/tags_dropdown.js